/* eslint-disable max-len */

/* Reference because the text is constant and is not necessary to translate it
  https://babel.adminml.com/docs/block/coverage#aplicaciones-que-usan-wordings-como-traducciones */
const disclaimerMLA = 'información para el usuario financiero';
const disclaimerMLB = {
  paragraph1: 'O Mercado Pago não realiza a prestação de serviços privativos de Instituição Financeira. O Mercado Pago, na qualidade de correspondente bancário no país, oferece aos seus usuários a possibilidade de contratação de crédito diretamente com a Instituição Financeira Parceira.',
  paragraph2: 'Crédito sujeito à aprovação. A oferta, valores e condições da oferta poderão ser alterados a qualquer momento, a critério da Instituição Financeira.',
};

export const getDisclaimerSectionContent = ({ i18n }) => ({
  moreInfo: {
    question: i18n.gettext('¿Quieres saber más?'),
    /* i18n-next-line except: [MLM] */
    helpText: i18n.jsx.gettext(
      'Conoce todo sobre la Línea de Crédito',
      {
        wrapper: 'font',
      },
    ),
    endText: '.',
  },
  sale: {
    MLB: disclaimerMLB,
    paragraph1: i18n.jsx.gettext(
      'Oferta de préstamo sujeta a revisión crediticia, comercial, y de riesgos de Mercado{0}Libre al momento de la solicitud efectuada por el usuario. La presente no implica una obligación de otorgar el préstamo, cuya aprobación definitiva quedará irrevocablemente condicionada al cumplimiento de las condiciones exigibles por Mercado{0}Libre.',
      {
        wrapper: 'font',
        tags: {
          0: '&nbsp;',
        },
      },
    ),
    paragraph2: {
      first: i18n.gettext('Conoce más'),
      second: disclaimerMLA,
      endText: '.',
    },
    paragraph3: i18n.jsx.gettext(
      'Las marcas adheridas que se muestran en este sitio no son propiedad de Mercado{0}Libre, perteneciendo a sus respectivos titulares.',
      {
        wrapper: 'font',
        tags: {
          0: '&nbsp;',
        },
      },
    ),
    paragraph4: i18n.jsx.gettext(
      'Mercado{0}Pago ofrece servicios de pago y no está autorizado por el Banco Central a operar como entidad financiera. Los fondos acreditados en cuentas de pago no constituyen depósitos en una entidad financiera ni están garantizados conforme legislación aplicable a depósitos en entidades financieras.',
      {
        wrapper: 'font',
        tags: {
          0: '&nbsp;',
        },
      },
    ),
  },
});
